import {NotificaAttivita, TIPO_NOTIFICA} from '../../models/notifica-attivita';
import {OperationsService} from '../../services/operations.service';
import {ViewManagerService} from '../../services/view-manager-service';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FrontEndMapping} from '../../configuration/front-end-mapping';
import {Router} from '@angular/router';

@Component({
  selector: '[notifiche-list]',
  templateUrl: 'notifiche-list.component.html',
})

export class NotificheListComponent implements OnInit {

  @Input()
  notifiche: NotificaAttivita[];

  @Input()
  slice: number;

  @Input()
  hasOptions: boolean;

  @Output()
  onReturn: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private viewManager: ViewManagerService,
    private operationsService: OperationsService,
    private frontEndMapping: FrontEndMapping,
    private router: Router
  ) {
  }

  ngOnInit() {
    if (this.slice && this.slice > 0 && this.slice < this.notifiche.length) {
      this.notifiche = this.notifiche.slice(0, this.slice);
    }
  }

  segnalaComeLetta(notifica: NotificaAttivita) {
    this.operationsService.segnalaNotificaLetta(notifica.idNotifica).subscribe(response => {
      if (response === true || response === false)
        this.notificaLetta(notifica, response)
    });
  }

  notificaLetta(notifica: NotificaAttivita, response: boolean) {
    notifica.letta = response;
    this.viewManager._refreshNotifiche.next({});
  }

  elimina(notifica: NotificaAttivita) {
    this.operationsService.eliminaNotifica(notifica.idNotifica).subscribe(response => this.notificaEliminata(notifica));
  }

  notificaEliminata(notifica: NotificaAttivita) {
    notifica.eliminata = true;
    const indRemove = this.notifiche.findIndex(n => n.idNotifica === notifica.idNotifica);
    if (indRemove >= 0) {
      this.notifiche.splice(indRemove, 1);
    }
    this.viewManager._refreshNotifiche.next({});
    this.onReturn.emit();
  }

  getPraticaPathFromType(idTipoPratica: string) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(idTipoPratica).subscribe(res => {
      tipoPratica = res;
    });
    return tipoPratica;
  }

  tipoFascicoloString(idTipoFascicolo: string) {
    let tipoFascicolo = '';
    this.frontEndMapping.getListTipiFascicolo(idTipoFascicolo).subscribe(res => {
      tipoFascicolo = res;
    });
    return tipoFascicolo;
  }


  navigateToUrlNotifica(notifica: NotificaAttivita) {
    if (notifica.payload.TipoNotifica === TIPO_NOTIFICA.ELABORAZIONE_DOCUMENTI) {
      return `../gestione-documenti/dettaglio/${notifica.payload.idElaborazione}`;
    } else {
      return `../fascicolo/${this.getPraticaPathFromType(notifica.payload.idTipoPratica)}/${this.tipoFascicoloString(notifica.payload.idTipoFascicolo)}/${notifica.payload.idFascicolo}`
    }
  }

}
